import { render, staticRenderFns } from "./promotions.vue?vue&type=template&id=30d41539&scoped=true"
import script from "./promotions.vue?vue&type=script&lang=js"
export * from "./promotions.vue?vue&type=script&lang=js"
import style0 from "./promotions.vue?vue&type=style&index=0&id=30d41539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d41539",
  null
  
)

export default component.exports